import React from 'react';
import { Link } from 'react-router';
import { Trans } from '@lingui/macro';
import classNames from 'classnames';
import { connect } from 'react-redux';
import map from 'lodash/map';
import withFeatureFlags from 'hocs/withFeatureFlags';
import { updateLanguage } from '../../../state/i18n/actions';
import styles from './NavNotLoggedIn.css';

function LanguageMenu(props) {
  const { localeId, onChange } = props;

  const locales = {
    id: 'Bahasa Indonesia',
    en: 'English',
  };

  return (
    <li
      className="dropdown"
      data-toggle="collapse"
      data-target=".navbar-collapse.in"
    >
      <a
        href="#"
        className="dropdown-toggle"
        data-toggle="dropdown"
        role="button"
      >
        <span className="fa fa-globe" />
        &nbsp;
        <span>{locales[localeId]}</span>
        &nbsp;
        <span className="caret" />
      </a>

      <ul className="dropdown-menu" role="menu">
        {map(locales, (locale, key) => (
          <LanguageItem
            key={key}
            isSelected={key === localeId}
            onClick={() => onChange(key)}
          >
            {locale}
          </LanguageItem>
        ))}
      </ul>
    </li>
  );
}

function LanguageItem(props) {
  const { children, isSelected = false, onClick = () => {} } = props;

  return (
    <li className={styles.languageItem}>
      <a href="#" onClick={onClick}>
        <span
          className={classNames('glyphicon glyphicon-ok', styles.selectedIcon, {
            [styles.activeSelectedIcon]: isSelected,
          })}
        />
        {children}
      </a>
    </li>
  );
}

function NavNotLoggedIn(props) {
  const {
    localeId,
    location,
    updateLanguage,
    canChangeLanguage = false,
  } = props;

  const signInStyle = location.pathname === '/login' ? { color: 'white' } : {};
  if (location.pathname === '/register-complete') {
    return <div />;
  }
  return (
    <div
      className={`navbar-collapse collapse header-login ${styles.wrapper}`}
      id="NavNotLoggedIn"
    >
      <ul
        className={`nav navbar-nav mk-navbar-nav navbar-right text-center ${
          styles['list-menu']
        }`}
      >
        {canChangeLanguage && (
          <LanguageMenu localeId={localeId} onChange={updateLanguage} />
        )}

        <li>
          <a
            href="https://mokaposhelp.zendesk.com/hc/id"
            data-toggle="collapse"
            data-target=".navbar-collapse.in"
          >
            <Trans>help</Trans>
          </a>
        </li>
        <li>
          <Link
            to="/login"
            data-toggle="collapse"
            data-target=".navbar-collapse.in"
            style={signInStyle}
          >
            <Trans>Sign In</Trans>
          </Link>
        </li>
      </ul>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    localeId: state.i18n.localeId,
  };
}

const mapDispatchToProps = {
  updateLanguage,
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(NavNotLoggedIn);

function mapFlagsToProps(flags) {
  return {
    canChangeLanguage: flags.enableLanguageSettings,
  };
}

export default withFeatureFlags(mapFlagsToProps)(connected);
